'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picture = exports.PictureUnwrapped = exports.mapStateToProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _decorator = require('helpers/decorator');

var _device = require('redux/modules/device');

var _mediaQueries = require('constants/media-queries');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isPhone: (0, _device.detectScreenType)(state) === _mediaQueries.SCREEN_TYPES.phone
  };
};

var PictureUnwrapped = exports.PictureUnwrapped = function PictureUnwrapped(_ref) {
  var isPhone = _ref.isPhone,
      phone = _ref.phone,
      tablet = _ref.tablet,
      title = _ref.title;

  var source = isPhone ? phone : tablet;

  return _react2.default.createElement(
    'div',
    { className: 'Picture' },
    isPhone && phone && _react2.default.createElement('img', { src: source, alt: title, title: title }),
    !isPhone && tablet && _react2.default.createElement('img', { src: source, alt: title, title: title })
  );
};

PictureUnwrapped.propTypes = {
  isPhone: _propTypes2.default.bool,
  phone: _propTypes2.default.string,
  tablet: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired
};

var Picture = exports.Picture = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps))(PictureUnwrapped);